export function sortByKeyComparator(key: string, direction?: number) {
    if (!direction) {
        direction = 1;
    }

    direction = direction * -1;

    return (a, b) => {
        if (a[key] > b[key]) {
            return 1 * direction;
        }

        if (a[key] < b[key]) {
            return -1 * direction;
        }

        return 0;
    };
}

export function arrayMove(arr, previousIndex, newIndex) {
    const array = arr.slice(0);
    if (newIndex >= array.length) {
        let k = newIndex - array.length;
        while (k-- + 1) {
            array.push(undefined);
        }
    }
    array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
    return array;
}


// WEBPACK FOOTER //
// ./src/components/widget/util/ArrayUtil.ts